import { ArrowUpOutlined, ArrowDownOutlined, EnterOutlined } from '@ant-design/icons';
import { T, useTranslate } from '@tolgee/react';
import { Badge } from 'antd';

export const PhraseToolbar = ({
  mercadoQAmode,
  hotkeyEnable = true,
}: {
  mercadoQAmode?: boolean;
  hotkeyEnable?: boolean;
}) => {
  const { t } = useTranslate();

  if (!hotkeyEnable) {
    return (
      <div className="inline-flex items-center gap-2">
        <div className="text-xs text-content-200">
          {t('scene.chatWorkspace.quickReply.hint.tabToActivateShortcut')}
        </div>
      </div>
    );
  }

  return (
    <div className="inline-flex items-center gap-2">
      <div className="text-xs text-content-200">
        <Badge
          color="var(--ant-primary-3)"
          text={
            <T
              keyName="chat_phrase_toolbar_tips1"
              params={{
                x: (
                  <>
                    <ArrowUpOutlined />
                    <ArrowDownOutlined />
                  </>
                ),
              }}
            />
          }
        />
      </div>
      <div className="text-xs text-content-200">
        <Badge
          color="var(--ant-primary-3)"
          text={
            mercadoQAmode ? (
              ['[', <EnterOutlined />, ']', t('reply.应用')]
            ) : (
              <T
                keyName="chat_phrase_toolbar_tips2"
                params={{
                  x: <EnterOutlined />,
                }}
              />
            )
          }
        />
      </div>
    </div>
  );
};
